import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from 'classnames';

var IconWrapper = /*#__PURE__*/React__default.forwardRef(function (_a, outerRef) {
  var children = _a.children,
    className = _a.className,
    style = _a.style,
    _a$size = _a.size,
    size = _a$size === undefined ? 16 : _a$size,
    otherProps = __rest(_a, ["children", "className", "style", "size"]);
  return jsx("span", Object.assign({
    className: classNames('cogs-icon-wrapper', className),
    style: Object.assign({
      width: size,
      height: size
    }, style),
    ref: outerRef
  }, otherProps, {
    children: children
  }));
});

export { IconWrapper };
